'use client';

import { Filter } from 'lucide-react';

import { clsx } from 'clsx';

import { ICON_DEFAULT } from '@shared/constants/colors';
import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';

import { EXCLUDED_FILTERS } from '../../../config/filters';
import { openAllFiltersModal } from '../../../model/slice/categorySlice';
import cls from './AllFilters.module.scss';

type AllFiltersButtonProps = {
  className?: string;
};

export const AllFiltersButton = ({ className }: AllFiltersButtonProps) => {
  const dispatch = useAppDispatch();
  const activeFilters = useAppSelector((state) => state.category.prevActiveFilters);
  const activeFiltersLength = Object.keys(activeFilters).filter((key) => !EXCLUDED_FILTERS.includes(key)).length;

  const openModalHandler = () => {
    dispatch(openAllFiltersModal());
  };

  return (
    <button
      data-testid="all-filters-button-desktop"
      aria-label={'Показать все фильтры'}
      onClick={openModalHandler}
      className={clsx(cls.wrap, className)}
    >
      <Filter
        size={18}
        color={ICON_DEFAULT}
      />
      <span>Все фильтры</span>
      {activeFiltersLength > 0 && <div className={cls.quantity}>{activeFiltersLength}</div>}
    </button>
  );
};
